import { render, staticRenderFns } from "./DatedGoalForm.vue?vue&type=template&id=734b4502&scoped=true"
import script from "./DatedGoalForm.vue?vue&type=script&lang=js"
export * from "./DatedGoalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734b4502",
  null
  
)

export default component.exports